import * as types from './types';
import { loading } from 'State/actions';
import { has } from 'lodash';

export const fetchData = () => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.VERIFICATION_SELECTION_LOADING, true));

    try {
      const response = await MPWWebApi.getGeneric(
        'Verification/GetVerificationSelection'
      );
      dispatch({
        type: types.VERIFICATION_SELECTION_GET_DATA,
        payload: response.data.Data,
      });
    } catch (error) {
      dispatch({
        type: types.VERIFICATION_SELECTION_FETCH_ERROR,
        payload: error.response,
      });
    }

    dispatch(loading(types.VERIFICATION_SELECTION_LOADING, false));
  };
};

export const processVerification = data => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.VERIFICATION_SELECTION_LOADING, true));
    try {
      const response = await MPWWebApi.postGenericInsertUpdate(
        'Verification/WriteProcessVerificationSelection',
        data
      );
      dispatch({
        type: types.VERIFICATION_SELECTION_SET_RESULT,
        payload: { message: response.data.Data.Message, isError: false },
      });
    } catch (error) {
      if (has(error, 'response.data.Data.Message')) {
        dispatch({
          type: types.VERIFICATION_SELECTION_SET_RESULT,
          payload: { message: error.response.data.Data.Message, isError: true },
        });
      } else {
        dispatch({
          type: types.VERIFICATION_SELECTION_FETCH_ERROR,
          payload: error.response,
        });
      }
    }

    dispatch(loading(types.VERIFICATION_SELECTION_LOADING, false));
  };
};

export const startOver = () => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.VERIFICATION_SELECTION_LOADING, true));
    try {
      await MPWWebApi.postGenericInsertUpdate(
        'Verification/WriteStartOverVerification'
      );

      dispatch({
        type: types.VERIFICATION_SELECTION_SET_RESULT,
        payload: {
          isError: false,
          message: 'Verification successfully started over.',
        },
      });
    } catch (error) {
      dispatch({
        type: types.VERIFICATION_SELECTION_FETCH_ERROR,
        payload: error.response,
      });
    }

    dispatch(loading(types.VERIFICATION_SELECTION_LOADING, false));
  };
};

export const clearProcessResult = () => {
  return {
    type: types.VERIFICATION_SELECTION_CLEAR_PROCESS_RESULT,
  };
};



// WEBPACK FOOTER //
// ./src/pages/verificationselection/state/selection/actions.js